import React, { Fragment } from "react";

const UnfollowUser = ({
  unfollowedUser,
  setShowUnfollowUser,
  unfollowUser,
}) => {
  return (
    <Fragment>
      <Fragment>
        <div className="messages-overlay">
          <div className="request-box">
            <i
              className="fas fa-times fa-3x message-x"
              onClick={() =>
                setShowUnfollowUser({ request: false, confirm: false })
              }
            ></i>
            <div className="flex-center">
              <div className="online-avi-container">
                <div
                  className={`avi-color-border ${
                    unfollowedUser.role === "innovator"
                      ? "green"
                      : unfollowedUser.role === "mentor"
                      ? "red"
                      : unfollowedUser.role === "employer"
                      ? "blue"
                      : null
                  }`}
                >
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${unfollowedUser.avatar}`}
                    className="drop-down-result-avi"
                    alt="avatar"
                  />
                </div>
              </div>
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span
                      className={`name-font ${
                        unfollowedUser.role === "innovator"
                          ? "green"
                          : unfollowedUser.role === "mentor"
                          ? "red"
                          : unfollowedUser.role === "employer"
                          ? "blue"
                          : null
                      }`}
                    >
                      {unfollowedUser.firstname} {unfollowedUser.lastname}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {unfollowedUser.jobtitle}
                  </li>
                  <li className="user-online-item">
                    {unfollowedUser.location.city},{" "}
                    {unfollowedUser.location.state}
                  </li>
                </ul>
              </div>
            </div>
            <div className="user-request-text">
              Would you like to unfollow{" "}
              <span
                className={`bold ${
                  unfollowedUser.role === "innovator"
                    ? "green"
                    : unfollowedUser.role === "mentor"
                    ? "red"
                    : unfollowedUser.role === "employer"
                    ? "blue"
                    : null
                }`}
              >
                {unfollowedUser.firstname} {unfollowedUser.lastname}
              </span>
              ?
            </div>
            <div className="flex-center">
              <button
                className={`user-request-button ${
                  unfollowedUser.role === "innovator"
                    ? "background-green"
                    : unfollowedUser.role === "mentor"
                    ? "background-red"
                    : unfollowedUser.role === "employer"
                    ? "background-blue"
                    : null
                }`}
                onClick={() => {
                  unfollowUser({ unfollowedUser });
                  setShowUnfollowUser({
                    request: false,
                    confirm: true,
                  });
                }}
              >
                <i className="far fa-check-circle fa-sm mr-5"></i>
                Confirm
              </button>
              <button
                className={`user-request-button ${
                  unfollowedUser.role === "innovator"
                    ? "background-green"
                    : unfollowedUser.role === "mentor"
                    ? "background-red"
                    : unfollowedUser.role === "employer"
                    ? "background-blue"
                    : null
                }`}
                onClick={() =>
                  setShowUnfollowUser({
                    request: false,
                    confirm: false,
                  })
                }
              >
                <i className="fas fa-times fa-sm mr-5 bold"></i>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Fragment>
    </Fragment>
  );
};

export default UnfollowUser;
